<template>
    <div class="event_main">
        <div class="header">
            <div class="main_hader_wrap">
                <div class="main_hader">
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <h1>
                        2026 <액션시민>
                        <span>반성매매 온라인캠페인</span>
                    </h1>
                </div>
            </div>
            <div class="main_title">
                <img src="@/assets/event_title.png" alt="" />
                <h2>성매매 CUT 시민 ACTION</h2>
            </div>
        </div>
        <div class="main_comment">
            <p>성매매 없는 사회를 위해 나아가는</p>
            <p><액션시민>참여자들이 목소리를 모으고 있습니다.</p>
            <p>
                공감되는 메시지를 선택하고,
                <span>당신의 한마디도 남겨주세요!</span>
            </p>
        </div>
        <div class="footer">
            <div>
                <p>
                    <label>참여기간</label>
                    7월 14일(화) ~ 7월 27일(월)
                </p>
                <p>
                    <label>당첨상품</label>
                    <span>
                        편의점 상품권 3,000원
                        <span>(100명 추첨)</span>
                    </span>
                </p>
                <p>
                    <label>당첨발표</label>
                    <span>
                        2026년 8월 3일(월)
                        <span class="info">*당첨자 홈페이지 게시 및 개별 문자 발송</span>
                    </span>
                </p>
            </div>
            <button class="start_btn" @click="emit('start')">시작하기</button>
            <img class="horse_left" src="@/assets/horse_left_pc.png" alt="" />
            <img class="horse_right" src="@/assets/horse_right_pc.png" alt="" />
        </div>
    </div>
</template>

<script lang="ts">
    export default {
        emits: ["start"],
        setup(props: any, { emit }: any) {
            return { emit };
        },
    };
</script>

<style scoped></style>
